import { render, staticRenderFns } from "./AddOrEditBookMark.vue?vue&type=template&id=188416b8&scoped=true"
import script from "./AddOrEditBookMark.vue?vue&type=script&lang=js"
export * from "./AddOrEditBookMark.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditBookMark.vue?vue&type=style&index=0&id=188416b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188416b8",
  null
  
)

export default component.exports